import { useState } from 'react';
import { Link } from 'react-router-dom';
import './Support.css';

const Support = () => {
  const [openCategories, setOpenCategories] = useState([]);

  const toggleCategory = (categoryId) => {
    setOpenCategories(prev =>
      prev.includes(categoryId)
        ? prev.filter(id => id !== categoryId)
        : [...prev, categoryId]
    );
  };

  const helpCategories = [
    {
      id: 1,
      title: "Account & Profile",
      questions: [
        {
          q: "How do I create an account?",
          a: "Download the Dangol app from the App Store or Google Play Store. Open the app and tap 'Sign Up' to create your account using your email address and phone number. You'll receive a verification code to confirm your account."
        },
        {
          q: "How do I update my profile information?",
          a: "Open the Dangol app and navigate to your profile by tapping the profile icon. From there, you can update your name, phone number, and other account details. Changes are saved automatically."
        },
        {
          q: "I forgot my password, what should I do?",
          a: "On the login screen, tap 'Forgot Password'. Enter your registered email address, and we'll send you a verification code to reset your password. Follow the instructions in the message to create a new password."
        }
      ]
    },
    {
      id: 2,
      title: "Rewards & Redemptions",
      questions: [
        {
          q: "How do I earn rewards?",
          a: "Visit any participating Dangol business and present your unique QR code from the app at their kiosk. Each scan counts toward your reward at that specific business. Different businesses may have different reward requirements."
        },
        {
          q: "Where can I see my rewards progress?",
          a: "Open the Dangol app and view your home screen. You'll see all participating businesses where you've earned stamps, along with your progress toward rewards at each location. Tap on any business to see detailed progress and available rewards."
        },
        {
          q: "How do I redeem my rewards?",
          a: "Once you've completed a reward card at a business, you can redeem your reward by scanning your QR code at the Dangol Kiosk."
        }
      ]
    },
    {
      id: 3,
      title: "App & Technical Issues",
      questions: [
        {
          q: "The app isn't loading properly",
          a: "First, make sure you have a stable internet connection. Try closing the app completely and reopening it. If the issue persists, check for app updates in your device's app store. Still having trouble? Contact us at support@dangolapp.com with details about your device and the issue."
        },
        {
          q: "I'm not receiving notifications",
          a: "Check that notifications are enabled for Dangol in your device settings. \n On iOS: Settings > Dangol > Notifications. \n On Android: Settings > Apps > Dangol > Notifications. \nAlso verify that you've opted in to receive notifications from specific businesses in the app settings."
        },
        {
          q: "How do I enable or disable notifications?",
          a: "In the Dangol app, go to Settings and tap 'Notifications' to disable notifications for the entire app. \n You can control notifications for each business individually by toggling it on or off on the businesses rewards page on the app. You can opt in or out at any time without affecting your rewards progress."
        },
        {
          q: "App crashes or freezes",
          a: "Try restarting your device and ensuring the app is updated to the latest version. If crashes continue, contact us at support@dangolapp.com and include your device model and OS version."
        }
      ]
    }
  ];

  return (
    <div className="support">
      <div className="support-container">
        <div className="support-header">
          <h1 className="support-title">Customer Support</h1>
          <p className="support-subtitle">We're here to help you with your Dangol rewards</p>
        </div>

        {/* Help Categories */}
        <div className="help-section">
          <h2 className="help-section-title">Common Questions</h2>
          <div className="help-categories">
            {helpCategories.map(category => (
              <div key={category.id} className="help-category">
                <button
                  className={`category-header ${openCategories.includes(category.id) ? 'active' : ''}`}
                  onClick={() => toggleCategory(category.id)}
                  aria-expanded={openCategories.includes(category.id)}
                >
                  <span className="category-title">{category.title}</span>
                  <span className="category-icon">
                    {openCategories.includes(category.id) ? '−' : '+'}
                  </span>
                </button>
                <div className={`category-content ${openCategories.includes(category.id) ? 'open' : ''}`}>
                  {category.questions.map((item, index) => (
                    <div key={index} className="support-faq-item">
                      <h3 className="support-faq-question">{item.q}</h3>
                      <p className="support-faq-answer">{item.a}</p>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Contact Card - De-emphasized, below FAQ */}
        <div className="quick-contact-card">
          <h2 className="contact-card-title">Still Need Help?</h2>
          <p className="contact-card-description">
            If you can't find an answer above, contact us at support@dangolapp.com
          </p>
        </div>

        {/* Footer Links */}
        <div className="support-footer">
          <Link to="/privacy" className="support-footer-link">Privacy Policy</Link>
          <span className="footer-separator">|</span>
          <Link to="/terms" className="support-footer-link">Terms of Service</Link>
        </div>
      </div>
    </div>
  );
};

export default Support;
